import axios from 'axios'
import { isMobile } from 'mobile-device-detect'


export default {

  checkIsMobile ({ commit }) {
    commit('SET_ISMOBILE', isMobile)
  },

  setMenuOpen ({ commit }, payload) {
    commit('SET_MENUOPEN', payload)
  },

  async getHome ({ commit }) {
    try {
      console.log('>> getHome')
      const res = await axios.get(apiUrl('/home'))
      console.log(res.data)
      commit('UPDATE_HOME', res.data)
    } catch (err) {
      throw err
    }
  },

  async getAbout ({ commit }) {
    try {
      console.log('>> getAbout')
      const res = await axios.get(apiUrl('/about'))
      console.log(res.data)
      commit('UPDATE_ABOUT', res.data)
    } catch (err) {
      throw err
    }
  },

  async getPrivacy ({ commit }) {
    try {
      console.log('>> getPrivacy')
      const res = await axios.get(apiUrl('/legal'))
      console.log(res.data)
      commit('UPDATE_PRIVACY', res.data)
    } catch (err) {
      throw err
    }
  },

  async getActivitiesList ({ commit }) {
    try {
      console.log('>> getActivitiesList')
      const res = await axios.get(apiUrl('/activities'))
      console.log(res.data)
      commit('UPDATE_ACTIVITIES_LIST', res.data)
    } catch (err) {
      throw err
    }
  },

  async getActivity ({ commit }, slug) {
    try {
      console.log('>> getActivity ' + slug)
      const res = await axios.get(apiUrl(`/activities/${slug}`))
      console.log(res.data)
      commit('UPDATE_ACTIVITIES', res.data)
    } catch (err) {
      throw err
    }
  },

  async getActivityGroup ({ commit }, slug) {
    try {
      console.log('>> getActivityGroup ' + slug)
      const res = await axios.get(apiUrl(`/activity-groups/${slug}`))
      console.log(res.data)
      commit('UPDATE_ACTIVITY_GROUPS', res.data)
    } catch (err) {
      throw err
    }
  },

  async getEventsList ({ commit }) {
    try {
      console.log('>> getEventsList')
      const res = await axios.get(apiUrl('/events'))
      console.log(res.data)
      commit('UPDATE_EVENTS_LIST', res.data)
    } catch (err) {
      throw err
    }
  },  

  async getEvent ({ commit }, slug) {
    try {
      console.log('>> getEvent ' + slug)
      const res = await axios.get(apiUrl(`/events/${slug}`))
      console.log(res.data)
      commit('UPDATE_EVENTS', res.data)
    } catch (err) {
      throw err
    }
  },


  async getArtworksList ({ commit }) {
    try {
      console.log('>> getArtworksList')
      const res = await axios.get(apiUrl('/artworks'))
      console.log(res.data)
      commit('UPDATE_ARTWORKS_LIST', res.data)
    } catch (err) {
      throw err
    }
  },  

  async getArtwork ({ commit }, slug) {
    try {
      console.log('>> getArtwork ' + slug)
      const res = await axios.get(apiUrl(`/artworks/${slug}`))
      console.log(res.data)
      commit('UPDATE_ARTWORKS', res.data)
    } catch (err) {
      throw err
    }
  },

  async getResource ({ commit }, slug) {
    try {
      console.log('>> getResource ' + slug)
      const res = await axios.get(apiUrl(`/resources/${slug}`))
      console.log(res.data)
      commit('UPDATE_RESOURCES', res.data)
    } catch (err) {
      throw err
    }
  },

  async getPerson ({ commit }, slug) {
    try {
      console.log('>> getPerson ' + slug)
      const res = await axios.get(apiUrl(`/people/${slug}`))
      console.log(res.data)
      commit('UPDATE_PEOPLE', res.data)
    } catch (err) {
      throw err
    }
  },

  async getTag ({ commit }, tag) {
    try {
      console.log('>> getTag ' + tag)
      const res = await axios.get(apiUrl(`/tags/${tag}`))
      console.log(res.data)
      commit('UPDATE_TAGS', { key: tag, data: res.data })
    } catch (err) {
      throw err
    }
  },
}

function apiUrl (path) {
  return process.env.VUE_APP_API_URL + path
}